// @ts-strict-ignore
import {
  AfterViewInit,
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LMBaseComponent } from '@base/lm-base.component';
import { LMContextService } from '@services/lm-context.service';
import { LMSuiteHomeToolbarService } from './lm-suite-home-toolbar.service';
import {
  LMLoggerService,
  LMBusyIndicatorService,
  LMRouteComponentService,
  LMComponentInfoService,
  RoamingUIProfileResponse,
  RoamingUIProfileResult,
  LMRoamingUIProfileService,
  LMModalOpenService,
  LMModalWrapperService
} from '@services/index';
import { LMGlobalPersonalizationService } from '@states/services/lm-global-personalization.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMDrillService } from '@services/lm-drill.service';
import { LMContextUtilService } from '@utils/lm-context-util.service';
import { Observable, Subscription } from 'rxjs';
import { LMToolbarComponent } from '@toolbar/lm-toolbar.component';
import { LMGlobalUtilService, LMUniqueIdService } from '@utils/index';
import { LMAppComponentService } from '@utils/lm-app-component.service';
import { LMBannerHeaderComponentRef } from '../banner/lm-banner-header-component-ref.service';
import { LMComponentTrackerService } from '@services/lm-component-tracker.service';

@Component({
  selector: 'lm-suite-home',
  standalone: false,
  templateUrl: './lm-suite-home.component.html',
  styleUrls: [ 'lm-suite-home.component.scss' ],
  providers: [ LMSuiteHomeToolbarService, LMDrillService, LMRoamingUIProfileService, LMComponentTrackerService ],
})
export class LMSuiteHomeComponent extends LMBaseComponent implements AfterViewInit, OnInit, OnDestroy {

  public availableApps: Array<LMWebAppSpec>;
  private routerEventsSubscription: Subscription;
  public preferredWebApp: string;
  public instructions = '';
  public hideTitleBar = false;
  public toolbarButtons: Observable<Array<LMToolbarButton>>;
  public pageTitle: string;
  public sectionTitle: string;
  public preferredWebAppUrl: string;
  public preferredWebAppTitle: string;
  public globalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
  public hasDefaultStartPage = false;
  private toolbarSectionTitle: string;
  public allowedToSetPreferred = false;
  public emptyMessage: SohoEmptyMessageOptions = null;
  public noAccess = false;

  @ViewChild(LMToolbarComponent) toolbar: LMToolbarComponent;

  @HostBinding('attr.data-automation-id') automationId = 'lm-suite-home';

  constructor(
    public    router: Router,
    public    route: ActivatedRoute,
    private   lmBannerHeaderCompRef: LMBannerHeaderComponentRef,
    private   lmComponentTrackerService: LMComponentTrackerService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    public    lmContextService: LMContextService,
    private   lmLoggerService: LMLoggerService,
    private   lmRouteComponentService: LMRouteComponentService,
    private   lmSuiteHomeToolbarService: LMSuiteHomeToolbarService,
    public    lmUrlUtilService: LMUrlUtilService,
    private   lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private   lmContextUtilService: LMContextUtilService,
    private   lmRoamingUIProfileService: LMRoamingUIProfileService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmUniqueIdService: LMUniqueIdService,
    private   lmGlobalUtilService: LMGlobalUtilService,
    protected lmAppComponentService: LMAppComponentService,
    protected lmModalWrapperService: LMModalWrapperService,
    protected lmModalOpenService: LMModalOpenService
  ) {
    super (lmBusyIndicatorService, lmComponentInfoService, lmUniqueIdService, lmAppComponentService, lmModalWrapperService, lmModalOpenService);
    this.allowedToSetPreferred = this.lmContextService.allowedToSetPreferred();
    this.noAccess = this.lmUrlUtilService.hasParam(window.location.href, 'noAccess');

    // setTimeout(() => {
    //   this.zone.run(() => {
    //     this.changeDetectionRef.detectChanges();
    //   });
    // });

    this.routerEventsSubscription = router.events.subscribe(event => {
      // if (event instanceof NavigationEnd) {
      //   // why do I have to cast this?
      //   this.lmRouteComponentService.setRouteComponent(<Component>this);
      // } else if (event instanceof NavigationStart) {
      //   // show busy indicator when leaving a route.
      //   this.lmBusyIndicatorService.showBusyIndicator();
      // }
    });
  }

  ngOnInit() {
    this.lmLoggerService.time({ id: '>> Total Home' });
    this.lmRouteComponentService.setRouteComponent(this as Component);
    this.hideTitleBar = this.lmContextService.isHideTitlebar();
    this.checkForDefaultStartPage();
  }

  ngAfterViewInit() {
    this.lmBusyIndicatorService.showBusyIndicator();

    if (!this.lmContextService.inMingleWidget() && !this.hasDefaultStartPage) {
      if (!this.hideTitleBar) {
        this.lmBannerHeaderCompRef.instance.toolbarButtons = this.lmSuiteHomeToolbarService.getToolbarButtonsObservable();
        this.lmBannerHeaderCompRef.instance.fullPageScroll = false;

        setTimeout(() => {
          this.toolbarSectionTitle = Soho.Locale.translate('AvailableApplications');
          this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = this.toolbarSectionTitle;
          this.instructions = Soho.Locale.translate('PreferredAppInstructions');
          this.lmSuiteHomeToolbarService.buildToolbar();
          if (!this.lmContextService.isBannerInRoute() && this.lmContextService.showBreadcrumbs()) {
            this.lmBannerHeaderCompRef.resetBreadCrumbs('SuiteHome');
            this.lmBannerHeaderCompRef.updateBreadcrumbs({
              id: undefined,
              category: 'SuiteHome',
              busClass: '',
              specName: 'SuiteHome',
              type: 'SYSTEM',
              title: this.toolbarSectionTitle,
              routeUrl: this.router.url
            });
          }
        }, 50);
      } else {
        this.toolbarButtons = this.lmSuiteHomeToolbarService.getToolbarButtonsObservable();

        setTimeout(() => {
          this.pageTitle = Soho.Locale.translate('SuiteHome');
          this.toolbarSectionTitle = Soho.Locale.translate('AvailableApplications');
          this.sectionTitle = this.toolbarSectionTitle;
          this.instructions = Soho.Locale.translate('PreferredAppInstructions');
          this.lmSuiteHomeToolbarService.buildToolbar();
        }, 50);
      }
    }

    setTimeout(() => {
      this.availableApps = this.lmContextService.getAccessibleWebApps();

      if (this.availableApps.length === 0) {
        this.emptyMessage = {
          title: Soho.Locale.translate('NoAvailableApplications'),
          icon: 'icon-empty-no-alerts-new',
          color: 'azure'
        };
      } else {
        if (this.noAccess) {
          this.instructions = Soho.Locale.translate('NoAccessToApplication');
        } else {
          this.instructions = Soho.Locale.translate('WebAppHomeInstructions');
          if (this.allowedToSetPreferred) {
            this.instructions = this.instructions + ' ' + Soho.Locale.translate('PreferredAppInstructions');
          }
        }
      }
      // Sort by webApp name.
      this.availableApps.sort((a, b) => {
        if (a.webAppName < b.webAppName) {
          return -1;
        } else if (a.webAppName > b.webAppName) {
          return 1;
        } else {
          return 0;
        }
      });

      // remove any webApp without a title defined.
      for (let i = 0; i < this.availableApps.length; i++) {
        if (!this.availableApps[i].webAppTitle) {
          this.availableApps.splice(i, 1);
          i--;
        }
      }

      const loadTime = this.lmLoggerService.timeEnd('>> Total Home', [ this, 'ngAfterViewInit()', 'end' ]);
      this.sendPageAnalytics(this.route?.routeConfig?.component?.name, loadTime);
      this.sendShortcut();
      this.lmBusyIndicatorService.hideBusyIndicator();
    }, 100);
  }

  ngOnDestroy() {
    this.lmComponentTrackerService.endComponentTracking();
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }
  }

  public getUserWebRequestId(): string {
    return 'SuiteHome' + '-' +this.getBaseCompId();
  }

  getComponentInfo(): LMComponentInfo {

    const preferredWebAppSpec = this.availableApps.find(webAppSpec => webAppSpec.webAppName === this.preferredWebApp);

    let specNames: string[] = [];
    for (let webAppSpec of this.availableApps) {
      specNames.push(webAppSpec.webAppName);
    }

    const suiteHomeInfo: LMComponentInfo = {
      componentType: 'SUITE_HOME',
      name: preferredWebAppSpec ? preferredWebAppSpec.webAppName : this.automationId,
      userWebRequestId: this.getUserWebRequestId(),
      type: 'Suite Home',
      drillbackUrl: this.router.url,
      module : 'web',
      reloadPageUrl: preferredWebAppSpec ? preferredWebAppSpec.webAppUrl : undefined,
      tenant: this.lmContextService.getContext() ? this.lmContextService.getContext().dataArea : undefined,
      hasConfigAccess: this.lmContextService.hasConfigAccess(),
    };

    return suiteHomeInfo;
  }

  getComponentPlaceHolder(): ViewContainerRef {
    return undefined;
  }

  isPreferredWebApp(webAppSpec: LMWebAppSpec) {
    return this.preferredWebApp === webAppSpec.webAppName;
  }

  private validWebApp(webApp: string) {
    const preferredWebAppSpec = this.availableApps.find(webAppSpec => webAppSpec.webAppName === this.preferredWebApp);
    if (!preferredWebAppSpec) {
      return false;
    }

    this.preferredWebAppUrl = preferredWebAppSpec.webAppUrl;
    this.preferredWebAppTitle = preferredWebAppSpec.webAppTitle;
    return true;
  }

  private sendPageAnalytics(componentName: string, loadTime: number): void {
    const busHomeSpec = { name: 'Home' };
    this.lmComponentTrackerService.endLoadTracking(componentName, this.router.url, this.getComponentInfo(), loadTime);
    this.lmComponentTrackerService.startComponentTracking(this.getComponentInfo(), loadTime);
  }

  private sendShortcut(): void {
    if (!this.hasDefaultStartPage) {
      const shortcutTitle = `${this.toolbarSectionTitle} / ${this.lmContextService.getContext().webAppTitle}`;
      this.lmContextUtilService.enableStandardShortcut(true, shortcutTitle);
    }
  }

  loadComponentState(): void {
  }

  saveComponentState(includeSubComponents?: boolean): void {
  }

  public onToolbarButtonButtonEvent(toolbarButtonEvent: LMToolbarButtonEvent): void {
  }

  public onAnchorClicked(webAppTitle: string) {
    const selectedWebApp = this.availableApps.filter(webApp => webApp.webAppTitle === webAppTitle);
    const webAppSpec: LMWebAppSpec = selectedWebApp[0];
    this.lmContextService.setClearNextPageState(true);
  }

  public onPreferredMenuEvent(event) {
    if (event.preferredWebAppRemoved) {
      this.preferredWebApp = '';
      this.availableApps = Object.assign([], this.availableApps);
    }
  }

  public checkForDefaultStartPage() {
    if (!this.lmContextService.inMingleWidget()) {
      let isValidWebApp = false;
      this.availableApps = this.lmContextService.getAccessibleWebApps();

      if (this.availableApps.length === 1) {
        isValidWebApp = true;
        this.preferredWebAppUrl = this.availableApps[ 0 ].webAppUrl;
        this.preferredWebAppTitle = this.availableApps[ 0 ].webAppTitle;
      } else {
        const context = this.lmContextService.getContext();
        if (context.roamingUIProfile && context.roamingUIProfile.landingPageDefault && context.roamingUIProfile.landingPageDefault[0].webApp !== '') {
          this.preferredWebApp = context.roamingUIProfile.landingPageDefault[0].webApp;
          isValidWebApp = this.validWebApp(this.preferredWebApp);

          if (isValidWebApp) {
            if (this.globalPersonalization.preferredWebApp !== this.preferredWebApp) {
              this.globalPersonalization.preferredWebApp = this.preferredWebApp;
              this.lmGlobalPersonalizationService.saveGlobalPersonalization(this.globalPersonalization);
            }
          } else {
            const clearWebApp = '';
            this.lmRoamingUIProfileService.setPreferredWebApp(clearWebApp)
              .subscribe(
                (results: RoamingUIProfileResponse) => {
                  if (results.status === RoamingUIProfileResult.COMPLETED) {
                    this.globalPersonalization.preferredWebApp = clearWebApp;
                    this.lmGlobalPersonalizationService.saveGlobalPersonalization(this.globalPersonalization);
                    this.lmLoggerService.log([ 'RoamingUIProfile updated' ]);
                  } else {
                    this.lmLoggerService.log([ 'RoamingUIProfile not updated' ]);
                  }
                });
          }
        }

        if (!isValidWebApp && (context.defaultStartingPage && context.defaultStartingPage !== '')) {
          this.preferredWebApp = context.defaultStartingPage;
          isValidWebApp = this.validWebApp(this.preferredWebApp);
        }

        if (!isValidWebApp && (this.globalPersonalization.preferredWebApp && this.globalPersonalization.preferredWebApp !== '')) {
          this.preferredWebApp = this.globalPersonalization.preferredWebApp;
          isValidWebApp = this.validWebApp(this.preferredWebApp);
        }
      }

      if (isValidWebApp) {
        this.hasDefaultStartPage = true;
        this.lmGlobalUtilService.navigateByUrl(this.preferredWebAppUrl);
        this.onAnchorClicked(this.preferredWebAppTitle);
      }
    }
  }
}
